import React, { useEffect, useState } from "react"

import { Navigate, Route, Routes } from "react-router-dom"
import StaffComponent from "../components/StaffRouteComponent/StaffRouteComponent"

import SignInPage from "../SignIn/SignIn"
import StaffOrderList from "../components/Order/StaffOrderList/StaffOrderList"
import Home from "../MarlinSurf/Home/Home"
import StockBoards from "../MarlinSurf/StockBoards/StockBoards"
import Profile from "../soft_dashboard/layouts/profile"
import StaffOrderPage from "../components/Order/StaffOrderPage/StaffOrderPage"
import StaffProductList from "../components/Product/StaffProductList/StaffProductList"
import StaffProductPage from "../components/Product/StaffProductPage/StaffProductPage"
import Dashboard from "../components/Dashboard/Dashboard"
import staffTheme from "../soft_dashboard/assets/theme"
import { ThemeProvider } from "@mui/material/styles"
import { userTheme } from "../assets/userTheme"
import StaffGalleryPage from "../components/Gallery/StaffGalleryPage/StaffGalleryPage"
import CartPage from "../MarlinSurf/Cart/CartPage"
import CheckoutStatus from "../MarlinSurf/CheckoutStatus/CheckoutStatus"
import CustomOrder from "../MarlinSurf/CustomOrder/CustomOrder"
import PrivacyPolicy from "../MarlinSurf/Policies/PrivacyPolicy"
import CookiePolicy from "../MarlinSurf/Policies/CookiePolicy"
import PageNotFound from "../components/core/PageNotFound/PageNotFound"
import StaffCartPage from "../components/Cart/StaffCartPage/StaffCartPage"
import StaffCartList from "../components/Cart/StaffCartList/StaffCartList"
import StaffOptionPage from "../Staff/StaffOptionPage/StaffOptionPage"
import StaffPresetList from "../Staff/StaffPresetList/StaffPresetList"
import StaffSettings from "../components/Settings/StaffSettings"

const ProtectedRoute = ({ children, isAuthenticated }) => {
  if (isAuthenticated === false) {
    return <Navigate to="/signin" replace />
  }
  return <ThemeProvider theme={staffTheme}> {children} </ThemeProvider>
}

const UserRoute = ({ children }) => {
  return <ThemeProvider theme={userTheme}> {children} </ThemeProvider>
}

const StaffUserRoute = ({ children, isAuthenticated }) => {
  if (isAuthenticated === false) {
    return <Navigate to="/signin" replace />
  }
  return <ThemeProvider theme={userTheme}> {children} </ThemeProvider>
}

const AppRouter = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(null)

  useEffect(() => {
    setIsAuthenticated(!!localStorage.getItem("token"))
  }, [])

  return (
    <Routes>
      {/* ── Auth ── */}
      <Route
        path="/signin"
        element={
          <SignInPage
            isAuthenticated={isAuthenticated}
            setIsAuthenticated={setIsAuthenticated}
          />
        }
      />

      {/* ══════════════════════════════════════
          STAFF ROUTES (protected)
         ══════════════════════════════════════ */}
      <Route
        path="/staff"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <StaffComponent>
              <Dashboard />
            </StaffComponent>
          </ProtectedRoute>
        }
      />
      <Route
        path="/staff/orders/:customer_facing_id"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <StaffComponent>
              <StaffOrderPage />
            </StaffComponent>
          </ProtectedRoute>
        }
      />
      <Route
        path="/staff/orders"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <StaffComponent>
              <StaffOrderList />
            </StaffComponent>
          </ProtectedRoute>
        }
      />
      <Route
        path="/staff/options"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <StaffComponent>
              <StaffOptionPage />
            </StaffComponent>
          </ProtectedRoute>
        }
      />
      <Route
        path="/staff/presets"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <StaffComponent>
              <StaffPresetList />
            </StaffComponent>
          </ProtectedRoute>
        }
      />
      <Route
        path="/staff/products/:id"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <StaffComponent>
              <StaffProductPage />
            </StaffComponent>
          </ProtectedRoute>
        }
      />
      <Route
        path="/staff/products"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <StaffComponent>
              <StaffProductList />
            </StaffComponent>
          </ProtectedRoute>
        }
      />
      <Route
        path="/staff/gallery"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <StaffComponent>
              <StaffGalleryPage />
            </StaffComponent>
          </ProtectedRoute>
        }
      />
      <Route
        path="/staff/carts/:id"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <StaffComponent>
              <StaffCartPage />
            </StaffComponent>
          </ProtectedRoute>
        }
      />
      <Route
        path="/staff/carts"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <StaffComponent>
              <StaffCartList />
            </StaffComponent>
          </ProtectedRoute>
        }
      />
      <Route
        path="/staff/settings"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <StaffComponent>
              <StaffSettings />
            </StaffComponent>
          </ProtectedRoute>
        }
      />

      {/* ══════════════════════════════════════
          STAFF CUSTOM ORDER (with staff view)
         ══════════════════════════════════════ */}
      <Route
        path="/custom-surfboard-order-staff/:customer_facing_id"
        element={
          <StaffUserRoute isAuthenticated={isAuthenticated}>
            <CustomOrder isStaff={true} />
          </StaffUserRoute>
        }
      />
      <Route
        path="/custom-surfboard-order-staff"
        element={
          <StaffUserRoute isAuthenticated={isAuthenticated}>
            <CustomOrder isStaff={true} />
          </StaffUserRoute>
        }
      />
      <Route
        path="/custom-surfboard-order-staff-preset/:editing_preset_id"
        element={
          <StaffUserRoute isAuthenticated={isAuthenticated}>
            <CustomOrder isStaff={true} presetEditor={true} />
          </StaffUserRoute>
        }
      />
      <Route
        path="/custom-surfboard-order-staff-preset"
        element={
          <StaffUserRoute isAuthenticated={isAuthenticated}>
            <CustomOrder isStaff={true} presetEditor={true} />
          </StaffUserRoute>
        }
      />

      {/* ══════════════════════════════════════
          PUBLIC USER ROUTES
         ══════════════════════════════════════ */}

      {/* Home — the single-page scrolling site */}
      <Route
        path="/"
        element={
          <UserRoute>
            <Home />
          </UserRoute>
        }
      />

      {/* Stock Boards */}
      <Route
        path="/stock-boards"
        element={
          <UserRoute>
            <StockBoards />
          </UserRoute>
        }
      />

      {/* Custom Order */}
      <Route
        path="/custom-surfboard-order/:customer_facing_id"
        element={
          <UserRoute>
            <CustomOrder />
          </UserRoute>
        }
      />
      <Route
        path="/custom-surfboard-order"
        element={
          <UserRoute>
            <CustomOrder />
          </UserRoute>
        }
      />

      {/* Cart */}
      <Route
        path="/cart"
        element={
          <UserRoute>
            <CartPage />
          </UserRoute>
        }
      />

      {/* Checkout status */}
      <Route
        path="/checkout-success"
        element={
          <UserRoute>
            <CheckoutStatus success={true} />
          </UserRoute>
        }
      />
      <Route
        path="/checkout-failed"
        element={
          <UserRoute>
            <CheckoutStatus success={false} />
          </UserRoute>
        }
      />

      {/* Policies */}
      <Route
        path="/privacy"
        element={
          <UserRoute>
            <PrivacyPolicy />
          </UserRoute>
        }
      />
      <Route
        path="/cookies"
        element={
          <UserRoute>
            <CookiePolicy />
          </UserRoute>
        }
      />

      {/* Legacy redirects — old standalone pages now live as sections on Home */}
      <Route path="/about" element={<Navigate to="/#about" replace />} />
      <Route path="/gallery" element={<Navigate to="/#gallery" replace />} />
      <Route path="/faq" element={<Navigate to="/#faq" replace />} />
      <Route path="/contact" element={<Navigate to="/#contact" replace />} />
      <Route path="/merchandise" element={<Navigate to="/" replace />} />
      <Route path="/merchandise/:id" element={<Navigate to="/" replace />} />
      <Route path="/surfboard-inventory" element={<Navigate to="/" replace />} />
      <Route path="/surfboard-inventory/:id" element={<Navigate to="/" replace />} />

      {/* 404 */}
      <Route
        path="*"
        element={
          <UserRoute>
            <PageNotFound />
          </UserRoute>
        }
      />
    </Routes>
  )
}

export default AppRouter
